import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ml-dialog-actions',
  template: `
    <div fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="8px">
      <button mat-button (click)="clickLeft.emit()">
        {{ buttonLeft | translate | uppercase }}
      </button>

      <button
        mat-flat-button
        color="primary"
        [disabled]="disable"
        (click)="clickRight.emit()"
      >
        {{ buttonRight | translate | uppercase }}
      </button>
    </div>
  `,
  styleUrls: ['./dialog-actions.component.scss']
})
export class DialogActionsComponent implements OnInit {
  @Input() buttonLeft = 'cancel';
  @Input() buttonRight = 'submit';
  @Input() disable = false;

  @Output() clickRight = new EventEmitter();
  @Output() clickLeft = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
